import { c as _c } from "react/compiler-runtime";
import { Box, Text, VStack } from '@chakra-ui/react';
import { ReactNode } from 'react';
export const ProfileField = t0 => {
  const $ = _c(7);
  const {
    label,
    children
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <Text color="colorPalette.fg/60" textStyle="labelXs">{label}</Text>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children) {
    t2 = <Box color="colorPalette.fg/90" fontFamily="longform" fontSize="sm" lineHeight="tall">{children}</Box>;
    $[2] = children;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <VStack align="stretch" gap={1.5}>{t1}{t2}</VStack>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};